import { BarChart3, FileText, PackageOpen, Users } from 'lucide-react'

import { SubTabShell, type SubTab } from '@/components/SubTabShell'

const SUBTABS: SubTab[] = [
  { path: '/main/receiving',            label: '전표별',   Icon: FileText,  matchExact: true, hint: '입고전표 입력·수정' },
  { path: '/main/receiving/by-partner', label: '거래처별', Icon: Users,     hint: '매입처별 매입 합계 + 상세' },
  { path: '/main/receiving/by-item',    label: '품목별',   Icon: BarChart3, hint: '품목별 매입 합계 + 상세' },
]

export function ReceivingShell() {
  return (
    <SubTabShell
      Icon={PackageOpen}
      title="입고처리"
      subtitle="매입 전표 입력 + 매입처별·품목별 조회"
      subtabs={SUBTABS}
    />
  )
}
